module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-trails-183b998d844f5eb26a87fb03874435f6.svg";